<template>
      <div fluid fill-height>
        <v-expand-x-transition>
          <landing-toolbar />
        </v-expand-x-transition>
        <v-container style="min-width:100% !important">
          <Permissions />
        </v-container>
      </div>
</template>
    
    <script>
   import Permissions from '../../components/Definiciones/PermisosDeAccesos/Permissions.vue';
    import LandingToolbar from '../../components/LandingToolbar/LandingToolbar.vue'
    export default {
      components: { Permissions, LandingToolbar },
    };
    </script>
    